import AutoScroll from './AutoScroll'

export default AutoScroll
